import { render } from "./UnsubForm.vue?vue&type=template&id=be9f48d6&scoped=true"
import script from "./UnsubForm.vue?vue&type=script&lang=js"
export * from "./UnsubForm.vue?vue&type=script&lang=js"

import "./UnsubForm.vue?vue&type=style&index=0&id=be9f48d6&scoped=true&lang=css"
import "./UnsubForm.vue?vue&type=style&index=1&id=be9f48d6&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9f48d6"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect,QInput});
